/**
 * API配置文件
 * 统一管理所有后端接口地址
 */

// 后端API基础地址
// 优先使用环境变量，如果没有配置则使用默认值
export const BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8001/api';

// API端点配置
export const API = {
  // 用户相关
  USER: {
    LOGIN: '/user/login',
    REGISTER: '/user/register',
    SEND_CODE: '/user/send-code',
    UPDATE_PASSWORD: '/user/update-password',
    UPDATE_PHONE: '/user/update-phone',
  },

  // 验证码相关
  CAPTCHA: {
    GENERATE: '/captcha/generate',
    VERIFY: '/captcha/verify',
  },

  // 文件相关
  FILE: {
    UPLOAD: '/files/upload',
    DOWNLOAD: '/files/download',
  },

  // 供需信息相关
  SUPPLY_DEMAND: {
    PUBLISH: '/supply-demand/publish',
    UPDATE: '/supply-demand',
    DELETE: '/supply-demand',
    DETAIL: '/supply-demand',
    LIST: '/supply-demand/list',
    SEARCH: '/supply-demand/search',
    HOT: '/supply-demand/hot',
    LATEST: '/supply-demand/latest',
    MY: '/supply-demand/my',
    CONTACT_INFO: '/supply-demand/contact-info',
    PUBLISH_DRAFT: '/supply-demand/{id}/publish',
  },

  // 线索相关
  CLUE: {
    SEARCH: '/clue/search',
    DETAIL: '/clue',
    CONTACT_INFO: '/clue/contact-info',
    PHONE: '/clue/phone',
    EMAIL: '/clue/email',
  },

  // 收藏相关
  FAVORITE: {
    ADD: '/favorite',
    DELETE: '/favorite',
    LIST: '/favorite/list',
  },

  // 分类相关
  CATEGORY: {
    LIST: '/category/list',
    TREE: '/category/tree',
  },

  // 标签相关
  LABEL: {
    LIST: '/label/list',
  },

  // 余额相关
  BALANCE: {
    MINE: '/balance/mine',
  },

  // 订单相关
  ORDER: {
    MY: '/order/record/my',
  },

  // VIP套餐相关
  VIP: {
    PACKAGES: '/vip/packages/list',
  },

  // 支付相关
  PAYMENT: {
    CREATE: '/payment/create',
    CALLBACK: '/payment/callback',
  },
};

/**
 * 获取完整的URL
 * @param {string} endpoint - API端点
 * @param {object} params - URL参数
 * @returns {string} 完整的URL
 */
export function getFullUrl(endpoint, params = {}) {
  let url = BASE_URL + endpoint;
  
  // 添加查询参数
  const queryString = Object.keys(params)
    .filter(key => params[key] !== null && params[key] !== undefined)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  
  if (queryString) {
    url += (url.includes('?') ? '&' : '?') + queryString;
  }
  
  return url;
}

/**
 * 获取验证码图片URL
 * @param {string} key - 验证码key
 * @returns {string} 验证码图片URL
 */
export function getCaptchaUrl(key) {
  return getFullUrl(API.CAPTCHA.GENERATE, { key, t: Date.now() });
}

/**
 * 获取文件上传URL
 * @returns {string} 文件上传URL
 */
export function getUploadUrl() {
  return BASE_URL + API.FILE.UPLOAD;
}

/**
 * 获取文件下载URL
 * @param {string} fileId - 文件ID
 * @returns {string} 文件下载URL
 */
export function getDownloadUrl(fileId) {
  return getFullUrl(API.FILE.DOWNLOAD, { fileId });
}

/**
 * 修复图片URL
 * 将数据库中存储的 localhost URL 替换为当前环境的 BASE_URL
 * @param {string} url - 原始图片URL
 * @returns {string} 修复后的图片URL
 */
export function fixImageUrl(url) {
  if (!url) return '';
  
  // 如果URL包含 localhost，替换为当前的 BASE_URL
  if (url.includes('localhost')) {
    // 提取文件路径部分（/api/files/download?fileName=xxx）
    const match = url.match(/\/api\/files\/download\?fileName=(.+)/);
    if (match) {
      return `${BASE_URL}/files/download?fileName=${match[1]}`;
    }
  }
  
  // 如果URL是相对路径，补全为完整URL
  if (url.startsWith('/api/')) {
    return BASE_URL.replace('/api', '') + url;
  }
  
  // 其他情况直接返回原URL
  return url;
}

export default {
  BASE_URL,
  API,
  getFullUrl,
  getCaptchaUrl,
  getUploadUrl,
  getDownloadUrl,
  fixImageUrl,
};
